import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom';
import Layout from '../../../layouts/page';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { config } from '../../../config';
import Spinner from '../../../components/spinner';
import Dropdown from './dropdown'
import Pagination from '../../../components/pagination'
import Backbtn from '../../../components/backbtn';
import utils from '../../../helpers/textEdit'

const Index = () => {
  const [rotators, setRotators] = useState({});
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 10; // Define how many items to display per page

  const token = localStorage.getItem('auth_token');
  const dropdownRef = useRef(null);

  // Fetch service provider data based on current page
  const fetchServiceProviders = (page) => {
    setLoading(true);
    axios
      .get(`${config.api_path}/rotators?page=${page}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        console.log("Rotator provider", response.data.data)
        setRotators(response.data.data);
        setTotal(response?.data?.meta?.total); // Set total pages
        setLoading(false);
      })
      .catch((error) => {
        console.log("error", error)
        if (error) {
          toast.error('Failed to fetch service provider. Please try again.');
          setLoading(false);
        }

      });
  };

  // Fetch data when component mounts or currentPage changes
  useEffect(() => {
    document.title = "Tuwe | Service Provider";
    fetchServiceProviders(currentPage);
  }, [currentPage]);

  const totalPages = Math.ceil(total / itemsPerPage);

  return (
    <Layout>
      <div className="col-lg-12 grid-margin stretch-card">
        <div className="card">
          <div className="card-body">
            <h3>Emergency Rotators</h3>
            
            <Backbtn />
            <span>
              {"Viewing page " + currentPage + " of " + totalPages + " pages"}
            </span>
            <Link to={`/rotators/create/`}>
              <button
                type="button"
                style={{ marginBottom: "10px", float: "right" }}
                className="btn btn-outline-primary"
              >
                New Emergency Rotator
              </button>
            </Link>
            {loading ? (
              <Spinner />
            ) : (
              <>
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>No.</th>
                        <th>Name</th>
                        <th>Position</th>
                        <th>Telephone</th>
                        <th>Estate</th>
                        <th>Subcategory</th>
                        <th>Visibility Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rotators && rotators.length > 0 ? (
                        rotators.map(
                          (rotator, index) => (
                            <tr key={rotator.id}>
                              <td>{(currentPage - 1) * 10 + index + 1}</td>
                              <td>
                                <Link
                                  to={`/service-provider/rotator/${rotator.id}/view`}
                                >
                                  {utils.capitalizeWords(
                                    rotator.name
                                  )}
                                </Link>
                              </td>
                              <td>
                                {rotator?.position}
                              </td>
                              <td>{rotator.telephone_number}</td>
                              <td>{rotator?.estate?.name}</td>
                              <td>{rotator?.service_sub_category?.name}</td>
                              <td>
                                {utils.visibiltyDisplay(rotator.visibility)}
                              </td>

                              <td>
                                <Dropdown
                                  rotatorId={rotator.id}
                                  onDelete={() =>
                                    fetchServiceProviders(currentPage)
                                  }
                                />
                              </td>
                            </tr>
                          )
                        )
                      ) : (
                        <tr>
                          <td colSpan="8" className="text-center">
                            No Emergency Rotator found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  setCurrentPage={setCurrentPage}
                />
              </>
            )}
          </div>
        </div>
      </div>
      <ToastContainer />
    </Layout>
  );
};

export default Index;
